const URL_PREFIX = {
  AUTH: '/user_info',
  WEB: '/passport/web',
  APP: '/passport/mobile',
  SSO_AFF: '/aff',
  WEB_AFF: '/passport/aff/web',
  MOBILE_AFF: '/passport/aff/mobile',
  COMMON: '/passport/common',
};
export const WEB_URL = {
  SEND_MOBILE_CODE: `${URL_PREFIX.WEB}/send_code/`,
  SEND_EMAIL_CODE: `${URL_PREFIX.WEB}/email/send_code/`,
  VERIFY_MOBILE_CODE: `${URL_PREFIX.WEB}/validate_code/`,
  VERIFY_EMAIL_CODE: `${URL_PREFIX.WEB}/email/verify/`,
  CHECK_MOBILE_CODE: `${URL_PREFIX.WEB}/mobile/check_code/`,
  CHECK_EMAIL_CODE: `${URL_PREFIX.WEB}/email/check_code/`,

  // login & register
  SMS_LOGIN: `${URL_PREFIX.WEB}/sms_login/`,
  SMS_LOGIN_ONLY: `${URL_PREFIX.WEB}/sms_login_only/`,
  SMS_LOGIN_CONTINUE: `${URL_PREFIX.WEB}/sms_login_continue/`,
  EMAIL_LOGIN: `${URL_PREFIX.WEB}/email/login/`,
  EMAIL_CODE_LOGIN: `${URL_PREFIX.WEB}/email/code_login/`,
  EMAIL_REGISTER_LOGIN: `${URL_PREFIX.WEB}/email/register_verify_login/`,
  EMAIL_REGISTER: `${URL_PREFIX.WEB}/email/register_verify/`,
  PWD_LOGIN: `${URL_PREFIX.WEB}/user/login/`,
  AUTH_LOGIN: `${URL_PREFIX.WEB}/auth/login/`,
  AUTH_LOGIN_ONLY: `${URL_PREFIX.WEB}/auth/login_only/`,
  AUTH_BIND_ONLY: `${URL_PREFIX.WEB}/auth/bind_login/`,
  MOBILE_BIND_ONLY: `${URL_PREFIX.WEB}/mobile/bind_login/`,
  MOBILE_EMAIL_REGISTER: `${URL_PREFIX.WEB}/mobile_email_register/`,
  MOBILE_REGISTER: '/passport/mobile/register/',
  MOBILE_OAUTH: '/passport/auth/show_oauth_mobile/',
  LOGOUT: `${URL_PREFIX.WEB}/logout/`,
  CHECK_LOGIN: '/passport/account/info/v2/',
  BIND_WITH_MOBILE_LOGIN: `${URL_PREFIX.WEB}/auth/bind_with_mobile_login/`,
  BIND_WITH_EMAIL_LOGIN: `${URL_PREFIX.WEB}/auth/bind_with_email_login/`,
  GET_QRCODE: `${URL_PREFIX.WEB}/get_qrcode/`,
  CHECK_QRCONNECT: `${URL_PREFIX.WEB}/check_qrconnect/`,
  SCAN_QRCODE: `${URL_PREFIX.WEB}/scan_qrcode/`,
  CONFIRM_QRCODE: `${URL_PREFIX.WEB}/confirm_qrcode/`,
  THIRD_AUTH: `${URL_PREFIX.WEB}/web_login/`,
  USERNAME_REGISTER: `${URL_PREFIX.WEB}/username/register/`,
  WEB_SHARE_LOGIN: `${URL_PREFIX.WEB}/auth/share_login/`,
  AUTH_LOGIN_URL: '/passport/auth/wap_login/',
  EMAIL_REGISTER_NO_VERIFY: `${URL_PREFIX.WEB}/email/register/`,
  EMAIL_REGISTER_NO_VERIFY_V2: `${URL_PREFIX.WEB}/email/register/v2/`,
  // bind
  MOBILE_BIND: `${URL_PREFIX.WEB}/mobile/bind/`,
  EMAIL_BIND: `${URL_PREFIX.WEB}/email/bind/`,
  AUTH_BIND: `${URL_PREFIX.WEB}/auth/bind/`,
  AUTH_UNBIND: `${URL_PREFIX.WEB}/auth/unbind/`,
  AUTH_SWITCH_BIND: `${URL_PREFIX.WEB}/auth/switch_bind/`,

  // rebind
  MOBILE_REBIND: `${URL_PREFIX.WEB}/mobile/change/`,
  EMAIL_REBIND: `${URL_PREFIX.WEB}/email/change/`,

  // forget password
  RESET_PWD_BY_MOBILE: `${URL_PREFIX.WEB}/password/reset/`,
  RESET_PWD_BY_EMAIL: `${URL_PREFIX.WEB}/email/password/reset/`,
  RESET_PWD_BY_MOBILE_TICKET: `${URL_PREFIX.WEB}/password/reset_by_ticket/`,
  FORCE_RESET_PWD_BY_MOBILE_TICKET:
    URL_PREFIX.WEB + '/password/forced_reset_by_mobile_ticket/',
  RESET_PWD_BY_EMAIL_TICKET: `${URL_PREFIX.WEB}/password/reset_by_email_ticket/`,
  FORCE_RESET_PWD_BY_EMAIL_TICKET:
    URL_PREFIX.WEB + '/password/forced_reset_by_email_ticket/',

  // password
  PWD_CHANGE_BY_MOBILE: `${URL_PREFIX.WEB}/password/change/`,
  PWD_UPDATE: `${URL_PREFIX.WEB}/password/update/`,
  PWD_CHANGE_BY_EMAIL: `${URL_PREFIX.WEB}/email/change_password/`,
  PWD_SET: `${URL_PREFIX.WEB}/password/set/`,
  PWD_HAS_SET: '/passport/password/has_set/',
  PWD_HAS_SET_V2: `${URL_PREFIX.WEB}/password/has_set/`,
  PWD_RESET_LOGIN_BY_EMAIL: `${URL_PREFIX.WEB}/email/password/reset_and_login/`,
  PWD_SET_BY_EAMIL_AND_LOGIN: `${URL_PREFIX.WEB}/email/password/reset_and_login/`,

  // verify
  ACCOUNT_VERIFY: `${URL_PREFIX.WEB}/account/verify/`,
  AUTH_VERIFY: `${URL_PREFIX.WEB}/auth/verify/`,
  SMS_AUTHORIZE: `${URL_PREFIX.WEB}/sms/authorize/`,
  AVAILABLE_WAYS: `${URL_PREFIX.WEB}/auth/available_ways/`,
  VERIFY_PWD_WITHOUT_LOGIN: `${URL_PREFIX.WEB}/account/verify_pwd_without_login/`,

  // cancel
  CANCEL_VERIFY_WAY: '/passport/auth/cancel_verify_way/',
  CANCEL_CHECK: `${URL_PREFIX.WEB}/cancel/check/`,
  CANCEL_CONFIRM: `${URL_PREFIX.WEB}/cancel/confirm/`,
  CANCEL_REQUEST: `${URL_PREFIX.WEB}/cancel/post/`,
  CANCEL_LOGIN: `${URL_PREFIX.WEB}/cancel/login/`,

  // extra
  CHECK_MOBILE_REGISTER: `${URL_PREFIX.WEB}/user/check_mobile_registered/`,
  // some paths without /
  CHECK_EMAIL_REGISTER: `${URL_PREFIX.WEB}/user/check_email_registered`,
  CHANGE_QRCODE_SUCCESS: '/passport/qrcode_twostep_verify/scan_qrcode/',
  CHANGE_QRCODE_CONFIRM: '/passport/qrcode_twostep_verify/confirm_by_ticket/',

  // open
  GET_OPEN_AUTH_INFO: '/passport/open/auth_info/v2/',
  OPEN_SEND_CODE: '/passport/open/send_code/',
  OPEN_SMS_AUTH: '/passport/open/web/sms/auth/',
  OPEN_ACCOUNT_AUTH: '/passport/open/web/account/auth/',
  OPEN_THIRD_AUTH: '/passport/open/web/third_party/auth/',
  OPEN_GET_QRCODE: '/passport/open/get_qrcode/',
  OPEN_CHECK_QRCODE: '/passport/open/check_qrcode',
  OPEN_TO_SCAN_QRCODE: '/passport/open/to_scan_qrcode/',
  OPEN_SCAN_QRCODE: '/passport/open/scan_qrcode/',
  OPEN_CONFIRM_QRCODE: '/passport/open/confirm_qrcode/',
  OPEN_WEB_AUTH: '/passport/open/web/auth/',
  // account
  ACCOUNT_INFO: `${URL_PREFIX.WEB}/account/info/`,
  ACCOUNT_SET: `${URL_PREFIX.WEB}/account/set/`,
  ACCOUNT_REGISTER_LOGIN_NAME: `${URL_PREFIX.WEB}/login_name/register/`,
  ACCOUNT_AUTH_CONFIG: `${URL_PREFIX.WEB}/auth/config/`,
  ACCOUNT_UPDATE_LOGIN_NAME: `${URL_PREFIX.WEB}/login_name/update/`,

  // user
  OAUTH_PROFILE: '/web/user/get/oauth_profile/',
  UPLOAD_AVATAR: '/web/user/update/upload_avatar/',
  UPDATE_USERINFO: '/web/user/update/user_info/',
  CHECK_DEFAULT_INFO: '/web/user/check/default_info/',
  GET_BACKGROUND_LIST:
    '/web/user/settings/{aid}/default_background_image_list/',
  GET_DEFAULT_AVATAR_LIST: '/web/user/settings/{aid}/default_avatar_list/',
  GET_RECOMMEND_NAME: '/web/user/settings/recommend_name/',
  UPLOAD_PICTURE: '/web/user/upload/pic/',
  CHECK_REMAIN_TIMES: '/web/user/get/remain_update_times/',
  DOWNLOAD_IMAGE: '/user/web/download/image/',
  DOWNLOAD_IMAGE_V2: '/user/web/download/image/v2/',
};
export const WEB_AFF_URL = {
  SEND_MOBILE_CODE: `${URL_PREFIX.WEB_AFF}/mobile/send_code/`,
  SEND_EMAIL_CODE: `${URL_PREFIX.WEB_AFF}/email/send_code/`,
  VERIFY_MOBILE_CODE: `${URL_PREFIX.WEB_AFF}/mobile/validate_code/`,
  VERIFY_EMAIL_CODE: `${URL_PREFIX.WEB_AFF}/email/verify/`,
  CHECK_MOBILE_CODE: `${URL_PREFIX.WEB_AFF}/mobile/check_code/`,
  CHECK_EMAIL_CODE: `${URL_PREFIX.WEB_AFF}/email/check_code/`,

  // login
  SMS_LOGIN: `${URL_PREFIX.WEB_AFF}/mobile/sms_login/`,
  EMAIL_LOGIN: `${URL_PREFIX.WEB_AFF}/email/code_login/`,
  PWD_LOGIN: `${URL_PREFIX.WEB_AFF}/user/login/`,
  OAUTH_LOGIN_CALL: `${URL_PREFIX.WEB_AFF}/oauth/login/call/`,
  OAUTH_LOGIN_ONLY: `${URL_PREFIX.WEB_AFF}/oauth/login_only/`,
  OAUTH_LOGIN: `${URL_PREFIX.WEB_AFF}/oauth/login/`,
  SUBJECT_LOGIN_LIST: `${URL_PREFIX.WEB_AFF}/subject/login_list/`,
  SUBJECT_LOGIN: `${URL_PREFIX.WEB_AFF}/subject/login/`,
  LOGOUT: `${URL_PREFIX.WEB_AFF}/logout/`,

  // register
  REGISTER_EMAIL_USER_ONLY: `${URL_PREFIX.WEB_AFF}/email/register/only_user/`,
  REGISTER_EMAIL: `${URL_PREFIX.WEB_AFF}/email/register/`,
  REGISTER_MOBILE_USER_ONLY: `${URL_PREFIX.WEB_AFF}/mobile/register/only_user/`,
  REGISTER_MOBILE: `${URL_PREFIX.WEB_AFF}/mobile/register/`,

  // forget password
  RESET_BY_MOBILE: `${URL_PREFIX.WEB_AFF}/mobile/password/reset/`,
  RESET_BY_EMAIL: `${URL_PREFIX.WEB_AFF}/email/password/reset/`,

  // invite
  MOBILE_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/mobile/invite/`,
  EMAIL_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/email/invite/`,
  // LARK_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/lark/invite/`,
  INVITE_LIST: `${URL_PREFIX.WEB_AFF}/invitation/list/`,
  CANCEL_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/cancel/`,
  RESEND_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/resend/`,
  UPDATE_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/update/`,
  CHECK_INVITE_VALID: `${URL_PREFIX.WEB_AFF}/invitation/check/`,
  ACCEPT_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/accept/`,

  // subject
  CREATE_BY_USERNAME: `${URL_PREFIX.WEB_AFF}/subject/username/create/`,
  CREATE_BY_MOBILE: `${URL_PREFIX.WEB_AFF}/subject/mobile/create/`,
  CREATE_BY_EMAIL: `${URL_PREFIX.WEB_AFF}/subject/email/create/`,
  SUBJECT_LIST: `${URL_PREFIX.WEB_AFF}/subject/all/list/`,
  SUBJECT_DEPUTY_LIST: `${URL_PREFIX.WEB_AFF}/subject/deputy/list/`,
  SUBJECT_IDENTITY_LIST: `${URL_PREFIX.WEB_AFF}/subject/identity/list/`,
  UPDATE_DEPUTY_INFO: `${URL_PREFIX.WEB_AFF}/deputy/update/`,
  FREEZE_DEPUTY: `${URL_PREFIX.WEB_AFF}/deputy/freeze/`,
  DELETE_DEPUTY: `${URL_PREFIX.WEB_AFF}/deputy/delete/`,
  UPDATE_SUBJECT_INFO: `${URL_PREFIX.WEB_AFF}/subject/update/`,
  FREEZE_SUBJECT: `${URL_PREFIX.WEB_AFF}/subject/freeze/`,

  // resource
  RESOURCE_LIST: `${URL_PREFIX.WEB_AFF}/resource/list/`,

  // role
  CREATE_ROLE: `${URL_PREFIX.WEB_AFF}/role/create/`,
  UPDATE_ROLE: `${URL_PREFIX.WEB_AFF}/role/update/`,
  BAN_ROLE: `${URL_PREFIX.WEB_AFF}/role/ban/`,
  ROLE_LIST: `${URL_PREFIX.WEB_AFF}/role/list/`,
  ROLE_INFO: `${URL_PREFIX.WEB_AFF}/role/info/`,

  // user
  CREATE_USER_WITH_ROLE: `${URL_PREFIX.WEB_AFF}/user/create_with_role/`,
  ADD_USER_ROLE: `${URL_PREFIX.WEB_AFF}/user_role/add/`,
  DELETE_USER_ROLE: `${URL_PREFIX.WEB_AFF}/user_role/del/`,
  USER_ROLE_LIST: `${URL_PREFIX.WEB_AFF}/user_role/list/`,
  ALL_USER_ROLE_LIST: `${URL_PREFIX.WEB_AFF}/user_role/all/list/`,
  USER_PERMISSIONS: `${URL_PREFIX.WEB_AFF}/user/permissions/`,

  // super
  SUCCESSOR_SEND_CODE: `${URL_PREFIX.WEB_AFF}/admin/successor/send_code/`,
  TRANSFER_MANAGER: `${URL_PREFIX.WEB_AFF}/admin/transfer/`,

  // switch
  MEMBER_SWITCH: `${URL_PREFIX.WEB_AFF}/member/switch/`,
};

export const WEB_SSO = {
  // mobile_verify
  MOBILE_CODE_URL: '/send_activation_code/',
  MOBILE_CODE_URL_V2: '/send_activation_code/v2/',
  // email_verify
  EMAIL_ACTIVATE_URL: '/send_email_activate_link/',
  EMAIL_ACTIVATE_URL_V2: '/send_email_activate_link/v2/',
  EMAIL_ACTIVATE_CODE_URL: '/send_email_activate_code/',
  EMAIL_ACTIVATE_CODE_URL_V2: '/send_email_activate_code/v2/',
  // login_status
  CHECK_LOGIN: '/check_login/',
  // mobile_login
  MOBILE_CODE_LOGIN_URL: '/quick_login/',
  MOBILE_CODE_LOGIN_URL_V2: '/quick_login/v2/',
  MOBILE_CODE_LOGIN_ONLY_URL: '/quick_login_only/',
  // password_login
  ACCOUNT_LOGIN_URL: '/account_login/',
  ACCOUNT_LOGIN_URL_V2: '/account_login/v2/',
  ACCOUNT_LOGIN_URL_V3: '/account_login/v3/',
  // auth_login
  AUTH_LOGIN_URL: '/passport/auth/wap_login/',
  BIND_WITH_MOBILE_LOGIN: '/bind_with_mobile_login/',
  AUTH_LOGIN: '/auth/login/',
  AUTH_LOGIN_ONLY: '/auth/login_only/',
  // logout
  LOGOUT: '/logout/',
  // email_login
  EMAIL_ACTIVATE_CODE_LOGIN: '/activate_email/code_login/',
  EMAIL_REGISTER: '/activate_email/register/',
  EMAIL_REGISTER_V2: '/activate_email/register/v2/',
  // mobile code register and login
  MOBILE_REGISTER_WITH_EMAIL: '/register/',
  MOBILE_REGISTER_WITH_EMAIL_V2: '/register/v2/',
  // password
  // get email code
  SSO_EMAIL_ACTIVATE_CODE_URL: '/sso/send_email_activate_code/',
  RESET_PASSWORD: '/reset_password/',
  RESET_PASSWORD_BY_EMAIL: '/activate_email/reset_password/',
  // bind_mobile
  BIND_MOBILE: '/bind_mobile/',
  // change_mobile
  CHANGE_MOBILE: '/change_mobile/',
  // quick_auth
  QUICK_AUTH: '/quick_auth/',
  // qrcode_login
  GET_QRCODE: '/get_qrcode/',
  CHECK_QRCONNECT: '/check_qrconnect/',
  SCAN_QRCODE: '/scan_qrcode/',
  CONFIRM_QRCODE: '/confirm_qrcode/',
  // register
  MOBILE_EMAIL_REGISTER: '/mobile_email_register/',
  // set password
  SET_PASWORD: '/password/set/',
};

export const APP_URL = {
  SEND_MOBILE_CODE: `${URL_PREFIX.APP}/send_code/`,
  CHECK_MOBILE_CODE: `${URL_PREFIX.APP}/check_code/`,
  UNBIND_UNUSABLE_MOBILE: `${URL_PREFIX.APP}/unbind_limited_unusable_mobile/`,

  // login
  BIND_WITH_MOBILE_LOGIN: '/passport/auth/bind_with_mobile_login/',
  AUTH_LOGIN: '/passport/auth/login/',

  // user
  OAUTH_PROFILE: '/user/get/oauth_profile/',

  // NOT USE
  // UPLOAD_AVATAR: '/user/update/upload_avatar/',
  // UPDATE_USERINFO: '/user/update/user_info/',
  // CHECK_DEFAULT_INFO: '/user/check/default_info/',
  // GET_BACKGROUND_LIST: '/user/settings/{aid}/default_background_image_list/',
  // GET_DEFAULT_AVATAR_LIST: '/user/settings/{aid}/default_avatar_list/',
  // GET_RECOMMEND_NAME: '/user/settings/recommend_name/',
  // UPLOAD_PICTURE: '/user/upload/pic/',
  // GET_USER_INFO: '/passport/account/info/v2/',
  // CHECK_REMAIN_TIMES: '/user/get/remain_update_times/',
  // DOWNLOAD_IMAGE: '/user/download/image/',
  // DOWNLOAD_IMAGE_V2: '/user/download/image/v2/',

  // location
};

export const AUTH_URL = {
  WEB_SDK_INIT: `${URL_PREFIX.AUTH}/common/v1/web_sdk_init/`,
};

export const SSO_AFF_URL = {
  MEMBER_SWITCH: `${URL_PREFIX.SSO_AFF}/member/switch/`,
};

export const MOBILE_AFF_URL = {
  MEMBER_SWITCH: `${URL_PREFIX.MOBILE_AFF}/member/switch/`,
};

export const COMMON_URL = {
  BIND_VERIFY_INFO: `${URL_PREFIX.COMMON}/register/web/bind_verify_info/`,
};
